// Hvem står som afsender på mails og SMS til kunder – ens i testversionen og i drift (send-mail, send-besked):
//  • Alle mails sendes FRA virksomhedens egen adresse på hoveddomænet (Indstillinger › Beskeder, fx booking@steamgreen.dk) –
//    også for brands/subdomæner. Er adressen tom, ikke på virksomhedens domæne, eller er domænet endnu ikke verificeret hos
//    Resend, bruges Freemis adresse (MAIL_FRA) i stedet.
//  • Afsendernavnet og looket (logo, farver) er brandets (fx "SteamFox"); SMS-afsenderen er brandets SMS-afsender.
//  • Beskeder i et andet brands navn end hovedbrandet slutter med "Powered by <hovedbrand>" (mail: sidste linje, SMS: " - Powered
//    by …", som tæller med i SMS-længden). Hovedbrandet selv får aldrig "powered by".
import type { KlientBrand } from './klient.ts';
import { email as tjekEmail } from './validering.ts';

export type BrandInfo = { navn: string; aktiv: boolean; afsender?: { sms: string; mail: string } | null; design?: KlientBrand | null };
export type Hovedbrand = { navn: string; sms: string; design: KlientBrand | null };
export type Afsender = { navn: string; sms: string; design: KlientBrand | null; powered: string | null };

/** "booking.steamgreen.dk" → "steamgreen.dk". */
export const hovedDomaene = (d: string) => d.toLowerCase().replace(/^https?:\/\//, '').split('/')[0].split('.').filter(Boolean).slice(-2).join('.');

/** Virksomhedens egen fra-adresse – kun hvis den ligger på virksomhedens domæne; ellers null (så bruges Freemis). */
export function egenFraAdresse(mailFra: string | null | undefined, klientDomaene: string | null | undefined): string | null {
  const a = tjekEmail(mailFra ?? '');
  const hd = hovedDomaene(klientDomaene ?? '');
  if (!a || !hd.includes('.')) return null;
  const dom = a.split('@')[1];
  return dom === hd || dom.endsWith('.' + hd) ? a : null;
}

/** Resend afviser, fordi domænet ikke er verificeret – så sendes mailen igen fra Freemis adresse. */
export const ikkeVerificeret = (grund: string) => /verif|not.*domain|domain.*not/i.test(grund);

/** Afsenderen for en besked: brandets navn og look, ellers hovedbrandets; "powered by" når det ikke er hovedbrandet. */
export function beskedAfsender(hoved: Hovedbrand, brand: BrandInfo | null | undefined): Afsender {
  if (!brand?.aktiv || !brand.navn || brand.navn === hoved.navn) return { navn: hoved.navn, sms: hoved.sms || hoved.navn, design: hoved.design, powered: null };
  return { navn: brand.afsender?.mail || brand.navn, sms: brand.afsender?.sms || brand.navn, design: brand.design ?? hoved.design, powered: hoved.navn };
}

/** Teksten med "Powered by <hovedbrand>" til sidst (kun for andre brands end hovedbrandet). Sættes kun på én gang. */
export function medPoweredBy(tekst: string, kanal: 'mail' | 'sms', powered: string | null): string {
  if (!powered) return tekst;
  const fod = `Powered by ${powered}`;
  if (tekst.trimEnd().endsWith(fod)) return tekst;
  return kanal === 'sms' ? `${tekst.trimEnd()} - ${fod}` : `${tekst.trimEnd()}\n\n${fod}`;
}
